import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/tags']['DELETE'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const deleteUserWorkflowTags = async ({userWorkflowId }: Input): Promise<Output> => {
  const response = await noodleApiClient.delete(`/workflows/user-workflows/${userWorkflowId}/tags`);
  return response.data;
};

export default deleteUserWorkflowTags;
